import React, { useEffect, useState } from "react";
import { Button, Container, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCategories } from "store/actions";
import { useLocation } from "react-router-dom";
import { getExplore } from "store/actions";
import LikeButton from "Component/Liked/LikeButton";

export default function ExploreCard(props) {
  const location = useLocation();
  let dispatch = useDispatch();
  const query = new URLSearchParams(location?.search);
  const token = query.get("value");

  const { getLikedPost, isLiked } = props;
  const [state, setState] = useState("all");
  const [Explore, setexplore] = useState([]);
  const [filter, setfilter] = useState({
    limit: 8,
    orderBy: "_id",
    order: -1,
    page: 1,
    author: "",
    collectionId: "",
    fields: [],
    fileType: [],
    isVarified: false,
    getNew: false,
    isMore: false,
  });

  const home = useSelector((state) => state?.home);
  const { user } = useSelector((state) => state?.Login);
  const { categories } = useSelector((state) => state?.categories);

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  useEffect(() => {
    if (token) {
      setfilter((prev) => ({
        ...prev,
        category: [token],
      }));
    }
  }, [token]);

  useEffect(() => {
    dispatch(getExplore(filter));
  }, [filter]);

  useEffect(() => {
    if (home?.explore) {
      if (filter.isMore) {
        setexplore((prevState) => [...prevState, ...home?.explore]);
      } else {
        setexplore(home?.explore);
      }
    }
  }, [home?.explore]);

  useEffect(() => {
    let res = categories?.find((d) => d?._id == token);
    if (res) {
      setState(res?.name);
    }
  }, [categories, token]);

  useEffect(() => {
    if (user?._id) {
      setfilter((prevState) => ({
        ...prevState,
        collectedAuthor: null,
        createdAuthor: null,
        author: user?._id,
        page: 1,
        isMore: false,
      }));
    }
  }, [user?._id]);

  const showMoreItems = (evt) => {
    evt.preventDefault();
    setfilter((prevState) => ({
      ...prevState,
      page: prevState.page + 1,
      isMore: true,
    }));
  };

  return (
    <section className="DigitalArtcollection-main position-relative">
      <Container>
        <div className="DigitalArtcollection-head">
          <h2>Explore Digital Artworks </h2>
          <p>Explore The Digital Artworks In The Most Featured Categories</p>
        </div>

        <div className="digitailart-tabbing">
          <div className="tab-frame">
            <>
              {categories && categories?.length > 0 && (
                <>
                  <div className="clearfix">
                    <input name="tab" type="radio" checked={state === "all"} />
                    <label
                      onClick={() => {
                        setState("all");
                        setfilter((prev) => ({
                          ...prev,
                          category: [],
                        }));
                      }}
                    >
                      All
                    </label>

                    {categories?.map((categoryItems, id) => {
                      return (
                        <>
                          <input
                            key={id}
                            type="radio"
                            name="tab"
                            checked={state === categoryItems?.name}
                          />
                          <label
                            onClick={() => {
                              setState(categoryItems?.name);
                              setfilter((prev) => ({
                                ...prev,
                                category: [categoryItems?._id],
                              }));
                            }}
                          >
                            {categoryItems?.name}
                          </label>
                        </>
                      );
                    })}
                  </div>
                </>
              )}
            </>
         
            <div className="explore-arts">
              {Explore && Explore?.length > 0 ? (
                <>
                  {Explore?.map((nftData, idx) => {
                    return (
                      <div className="explore-cards mt-3">
                        <Col>
                          <div key={idx}>
                            <Link
                              to={`/bidding?id=${nftData?._id}`}
                              className="collect-art"
                            >
                              <div className="digital-art-wrap">
                                <div className="digital-art-img position-relative">
                                  <img
                                    src={nftData?.media?.link}
                                    alt="g"
                                    className="img-fluid"
                                  />
                                  <Link to="">
                                    <LikeButton
                                      liked={nftData?.isLiked || isLiked}
                                      itemId={nftData?._id}
                                      getLikedPost={getLikedPost}
                                    />
                                  </Link>
                                </div>

                                <div className="digital-art-content">
                                  <div className="avatarwrap">
                                    <div className="avatars"></div>
                                    <p>{nftData?.name}</p>
                                  </div>
                                  <div className="digital-price">
                                    <div className="price-here position-relative">
                                      <div className="price-level">Price</div>
                                      <p className="m-0 price-show">
                                        {nftData?.price}
                                        <img
                                          src="images/poly.png"
                                          className="polygon_icon_home"
                                        />
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </Col>
                      </div>
                    );
                  })}
                </>
              ) : (
                <p>No Data Found !!</p>
              )}
            </div>
          </div>
        </div>

        {Explore?.length < home?.totalExplore && (
          <div className="text-center show-wrap">
            <Button onClick={showMoreItems} className="showmore">
              Show More Items
            </Button>
          </div>
        )}
      </Container>
    </section>
  );
}
